import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

import { AdminService } from '../../layout/modules/admin/services/admin/admin.service';
import { EventService } from '../../services/event/event.service';
import { HelperService } from '../../services/helper/helper.service';
import { UiService } from '../../services/ui/ui.service';
import swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'app-link-upload',
  templateUrl: './link-upload.component.html',
  styleUrls: ['./link-upload.component.css']
})
export class LinkUploadComponent implements OnInit, AfterViewInit {

  @Input()
  public links = [];
  @Output()
  public linksChange = new EventEmitter();

  public modalData = {
    link: null
  };

  constructor(
    private adminService: AdminService,
    public ui: UiService,
    private helper: HelperService,
    public event: EventService,
    private _helperService: HelperService
  ) { }

  ngOnInit() {
    this.event.on('link-upload', 'CourseLinkUploadInput.save', (data) => {
      this.onInputModalSubmitBtnClick(data);
    });
  }

  ngAfterViewInit() {
    $('#courseLinkModal').on('hidden.bs.modal', () => {
      this.modalData.link = null;
    });
  }

  generateNewLink(link = null) {
    return {
      id: link && link.id || null,
      name: link && link.name || '',
      url: link && link.url || '',
      showType: link && link.showType || '',
      published: link && link.published || true,
      order: link && link.order || this.links.reduce((maxOrder, data) => Math.max(maxOrder, data.order), 0) + 1,
    };
  }

  showCourseLinkModal() {
    $('#courseLinkModal').modal('show');
    this.event.emit('setCourseLinkModalData', this.modalData.link);
  }
  hideCourseLinkModal() {
    $('#courseLinkModal').modal('hide');
  }
  addLink() {
    this.modalData.link = this.generateNewLink();
    this.showCourseLinkModal();
  }
  editLink(link, index) {
    this.modalData.link = {
      ...this.generateNewLink(link),
      ref: link,
      index
    };
    this.showCourseLinkModal();
  }
  deleteLink(link, index) {
    if (!link.deleted) {
      link.deleted = true;
    } else {
      delete link.deleted;
    }
    // this.linksChange.emit(this.links.filter((_, i) => i !== index));
  }

  private isValidUrl(url) {
    try {
      const _url = new URL(url);
      return true;
    } catch (e) {
      return false;
    }
  }

  onInputModalSubmitBtnClick(data) {
    const { id, name, url, order, showType, published, ref, index } = data;

    if (!name || !url || !order) {
      swal('Warning', 'Name, URL & Order fields are required', 'warning');
      return;
    }
    // tslint:disable-next-line: max-line-length
    if (!this.isValidUrl(url)) {
      swal('Warning', 'Please enter a valid URL.', 'warning');
      return;
    }

    const link = { id, name, url, order, published, showType };
    if (!ref) {
      this.linksChange.emit([...this.links, link]);
    } else {
      ref.name = name;
      ref.url = url;
      ref.order = order;
      ref.showType = showType;
      ref.published = published;
    }


    this.hideCourseLinkModal();
  }
}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/shared/link-upload/link-upload.component.ts